import { axiosInstance } from "@/axios/interceptors";

export default {
  // announceList: (data: AnnounceListParam) => axiosInstance.get("/api/member/notice/list", { params: data }),

  getBanner: async () => {
    return await axiosInstance.get(`banner`);
  },
  
  getBannerImg: async (idx: number) => {
    return await axiosInstance.get(`banner/${idx}`, {
        responseType: "blob",
      });
  },
};
